import React from 'react';
import { useState} from 'react';
import axios from 'axios';
import Navigation from '../navigation/navigationVisiteur';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Alert } from 'react-bootstrap';



 


function InformationJoueur(props) {

  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [changement,setChangement] =useState(false);
  const [success,setSucces] = useState(false);
  const [numero,setNumero] = useState('');
  const [taille,setTaille] = useState('');
  const [maillot,setMaillot] = useState('');
  const [poid,setPoid] = useState('');
  const [poste,setPoste] = useState('');
  const apiUrl = process.env.REACT_APP_API_URL;



  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setChangement(false);
    setSucces(false)
    setError(null);
    if (parseInt(maillot, 10) === parseInt(props.userData.user.donnée.results[0].numero, 10) ){
      setError("Numéro de maillot identique à celui utilisé actuellement");
      setIsLoading(false);
      return;
    }
    else if (taille === props.userData.user.donnée.results[0].taile){
      setError("Taille identique");
      setIsLoading(false);
      return;
    }
    else if (numero === props.userData.user.donnée.results[0].contact){
      setError("Numéro de téléphone identique");
      setIsLoading(false);
      return;
    }
    else if (parseInt(poid, 10) === parseInt(props.userData.user.donnée.results[0].poid, 10)){
      setError("Poid identique");
      setIsLoading(false);
      return;
    }
    else if (poste === props.userData.user.donnée.results[0].poste){
      setError("Poste identique");
      setIsLoading(false);
      return;
    }



    try {
      await axios.patch(`${apiUrl}/parametre/modification/joueur`, {
            id:props.userData.user.donnée.results[0].id,
            numeroGSM : numero,
            maillot : maillot,
            poste : poste,
            poid : poid,
            taille : taille
      }, {
        withCredentials: true
      });

      setError(null);
      setIsLoading(false);
      setPoid('')
      setMaillot('')
      setNumero('')
      setPoste('')
      setTaille('')
      setSucces(true)
      setTimeout(() => {
        window.location.reload();
      }, 5000);

    } catch (error) {
      setIsLoading(false);
      if (error.response) {
        setError(error.response.data.message);
      } else {
        setError(true);
      }
    }
  };










        
  return (
  <>
  {isLoading && (
    <>
      <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br/>
            <span className="loader"></span>
      </div>
    </>

  )}
  {changement && (
      <Modal show={changement} onHide={() => {setChangement(false);}}>
        <Modal.Header closeButton>
          <Modal.Title>Modification de vos informations personnelles</Modal.Title>
        </Modal.Header>
        <Modal.Body>        
            <>Êtes-vous sûr de modifier vos informations personnelles ?</>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {setChangement(false);}}>
            Annuler
          </Button>
          <Button variant="primary" onClick={(e) => {handleSubmit(e)}} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>
            Modifier vos informations
          </Button>
        </Modal.Footer>
      </Modal>
      )}
  {props.userData ? (
    <>


        <h2 style={{textAlign:"center"}}>Informations personnelles</h2>
        {error && (
                <Alert key="danger" variant="danger" style={{fontSize:"15px", margin:"auto", width : "80%"}}>
                    Erreur ! {error}. 
                </Alert>
                )}
                {success && (
                        <Alert key="success" variant="success" style={{fontSize:"15px", margin:"auto", width : "80%"}}>
                        Félicitations ! Vos informations ont été modifiée avec succés.
                      </Alert>
              )}
          <div className="card-body">
            <div className="ajout2">
                <form className="Invite_Joueur"  onSubmit={(e) => { e.preventDefault(); setChangement(true); }}> 
                    <div>
                        <label htmlFor="nom" className="label-1" >
                        <br />Nom<br />
                        <input
                            name="nom"
                            type="text"
                            id="nom"
                            value={" "+ props.userData.user.donnée.results[0].nom_joueur}
                            readOnly
                        />
                        </label>
                    </div>
                    <div>
                        <label htmlFor="prenom" className="label-1" >
                        <br />Prénom<br />
                        <input
                            name="prenom"
                            type="text"
                            id="prenom"
                            value={" "+ props.userData.user.donnée.results[0].prenom}
                            readOnly
                        />
                        </label>
                    </div>
                    <div>
                        <label htmlFor="date_" className="label-1" >
                        <br />Date de naissance<br />
                        <input
                            name="date_"
                            type="date"
                            id="date_"
                            value={props.userData.user.donnée.results[0].date}
                            readOnly
                        />
                        </label>
                    </div>
                    <div>
                        <label htmlFor="mail" className="label-1" >
                        <br />Email<br />
                        <input
                            name="mail"
                            type="mail"
                            id="mail"
                            value={" "+ props.userData.user.donnée.results[0].email}
                            readOnly
                        />
                        </label>
                    </div>
                    <div>
                        <label htmlFor="telephone_" className="label-1" >
                        <br />Numéro de téléphone actuel<br />
                        <input
                            name="telephone_"
                            type="tel"
                            id="telephone_"
                            value={" " + props.userData.user.donnée.results[0].contact}
                            readOnly
                        />
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <label htmlFor="new_phone" className="label-1" >
                        <br />Changer de numéro de téléphone<br />
                        <input
                            name="new_phone"
                            placeholder="0490-508-401"
                            type="tel"
                            id="new_phone"
                            value = {numero}
                            onChange={(e) => setNumero(e.target.value)}
                        />
                        </label>
                        
                    </div>
                    <div>
                        <label htmlFor="taille" className="label-1" >
                        <br />Taille<br />
                        <input
                            name="taille"
                            type="text"
                            id="taille"
                            value={" " + props.userData.user.donnée.results[0].taile + "m"}
                            readOnly
                        />
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <label htmlFor="new_taille" className="label-1" >
                        <br />Changer de taille<br />
                        <input
                            name="new_taille"
                            placeholder="1.81"
                            type="number"
                            id="new_taille"
                            step="0.01"
                            min={0}
                            value={taille}
                            onChange={(e) => setTaille(e.target.value)}
                        />
                        </label>
                        
                    </div>
                    <div>
                        <label htmlFor="poid" className="label-1" >
                        <br />Poid<br />
                        <input
                            name="poid"
                            type="text"
                            id="poid"
                            value={" " + props.userData.user.donnée.results[0].poid + "Kg"}
                            readOnly
                        />
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <label htmlFor="new_poid" className="label-1" >
                        <br />Changer de poid<br />
                        <input
                            name="new_poid"
                            placeholder="80"
                            type="number"
                            id="new_poid"
                            value={poid}
                            onChange={(e) => setPoid(e.target.value)}
                        />
                        </label>
                        
                    </div>
                    <div>
                        <label htmlFor="Maillot" className="label-1" >
                        <br />Numéro de maillot<br />
                        <input
                            name="maillot"
                            type="text"
                            id="poste"
                            value={" " + props.userData.user.donnée.results[0].numero}
                            readOnly
                        />
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <label htmlFor="new_numero" className="label-1" >
                        <br />Changer de numéro<br />
                        <input
                            name="new_numero"
                            type="number"
                            id="new_numero"
                            placeholder="10"
                            min={1}
                            max={99}
                            value={maillot}
                            onChange={(e) => setMaillot(e.target.value)}
                        />
                        </label>
                        
                    </div>
                    <div>
                        <label htmlFor="Poste" className="label-1" >
                        <br />Poste<br />
                        <input
                            name="poste"
                            type="text"
                            id="poste"
                            value={" " + props.userData.user.donnée.results[0].poste}
                            readOnly
                        />
                        </label>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <label htmlFor="new_poste" className="label-1" >
                        <br />Nouveau poste<br />
                        <Form.Select                              
                              name="poste"
                              value={poste}
                              onChange={(e) => setPoste(e.target.value)}
                              
                              >
                            <option>Sélectionner</option>
                            <option value="Attaquant">Attaquant</option>
                            <option value="Milieu">Milieu</option>
                            <option value="Defenseur">Défenseur</option>
                            <option value="Gardien">Gardien</option>
                          </Form.Select>
                        </label>
                        
                    </div>


                    <br/>
                    <button type="submit" className="conect" style={{margin: "auto"}} >
                            Modifier vos informations personnelles
                        </button>
                </form>
                <br/>
            
            
            </div>
      
        </div>
      </>
      ) :(
        <>
        <Navigation/>        
      <div id="alert-message" className="alert" >
          <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
      </div></>
      )}
  </>
  );
}

export default InformationJoueur;
